import { WeightEstimationEndpoints } from '@/modules/inventory/weight-estimation/api/weightEstimationEndpoints'

/**
 * Weight Estimation endpoint instance
 * instantiate weight estimation api class with a different api path
 */
export const weightEstimationEndpoints = new WeightEstimationEndpoints()
